import RegionDetailView from './RegionDetail';

export default RegionDetailView;
